import { Component } from '@angular/core';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { Subscription } from 'rxjs';
import { Crumb } from 'src/app/shared/components/breadcrumbs/breadcrumbs.component';
import { PageTitle } from 'src/app/shared/constants/page-titles.enum';
import { UsfProductCardModeEnum } from 'src/app/shared/constants/usf-product-card-mode.enum';
import { Product } from 'src/app/shared/models/product.model';
import {
  EllipsisClickData,
  ProductClickData,
} from 'src/app/shared/models/usf-product-card.model';
import { OrderItemService } from 'src/app/shared/services/order-item.service';
import { DealsProductCardService } from 'src/app/shared/services/product-card/deals-product-card.service';
import { DealsService } from '../../services/deals.service';
import { Tracking } from '@panamax/app-state';
import { DealsProductsAnalyticsService } from '../../services/deals-products-analytics.service';
import { ViewDidEnter, ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { DealsTracingService } from '@app/deals/services/deals-tracing.service';
import { TranslateService } from '@ngx-translate/core';
import { SEARCH_PAGES_ENUM } from '@shared/constants/search-pages.enum';

@Component({
  selector: 'app-all-deals',
  templateUrl: './all-deals.page.html',
  styleUrls: ['./all-deals.page.scss'],
})
export class AllDealsPage
  implements ViewWillEnter, ViewDidEnter, ViewWillLeave {
  breadcrumbs: Crumb[];
  products: Product[];
  date: string;
  mode: UsfProductCardModeEnum = UsfProductCardModeEnum.promotions;
  isDealsLoadedSub$: Subscription;
  productsSub$: Subscription;

  constructor(
    readonly dealsService: DealsService,
    readonly platformService: PlatformService,
    readonly panAppState: PanAppState,
    private orderItemService: OrderItemService,
    private dealsProductCardService: DealsProductCardService,
    private dealsProductsAnalyticsService: DealsProductsAnalyticsService,
    private dealsTracingService: DealsTracingService,
    private translateService: TranslateService,
  ) {}

  ionViewWillEnter() {
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.allDeals),
    );
    this.date = Date();
    this.productsSub$ = this.dealsService
      .getAllDealsViewModel$()
      .subscribe((products: Product[]) => {
        this.products = products;
      });

    var homeCrumbUrl = this.platformService.isTouch.value
      ? '/touch/home'
      : '/desktop/home';

    this.breadcrumbs = [
      {
        label: 'i18n.breadcrumbs.home',
        url: homeCrumbUrl,
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.deals',
        url: '/deals',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.allDeals',
        url: '',
        active: true,
      },
    ];
  }

  ionViewDidEnter() {
    this.isDealsLoadedSub$ = this.dealsService
      .getAllDealsLoaded$()
      .subscribe(isLoaded => {
        if (isLoaded) {
          this.dealsProductsAnalyticsService.trackLoadDealsPage(this.products);
          this.dealsTracingService.traceAllAvailableDealsSuccess();
        }
      });
  }

  updateQuantity(event: any) {
    const trackingData: Tracking = {
      analytics: {
        data: {
          products: [{ addMethod: 'deals', merchFeatureName: 'deals' }],
        },
      },
    };
    this.orderItemService.changeQuantity(
      event.quantityUpdate.productNumber,
      event.quantityUpdate.quantity,
      event.quantityUpdate.isEaches,
      trackingData,
    );
  }

  clickEllipsis(event: EllipsisClickData) {
    const buttons = this.dealsProductCardService.constructEllipsisButtons(
      event,
      SEARCH_PAGES_ENUM.deals,
    );
    this.dealsProductCardService.openProductCardEllipsis(
      buttons,
      event.isTouch,
      event.event,
    );
  }

  clickPromotions(event: EllipsisClickData) {
    this.dealsProductCardService.openQuickViewModal(
      event,
      'productStatus',
      SEARCH_PAGES_ENUM.deals,
    );
  }

  clickCard(event: ProductClickData) {
    this.dealsProductCardService.routeToPDP(
      event.productNumber,
      event.isQuickView,
    );
  }

  clickInfo(event: EllipsisClickData) {
    this.dealsProductCardService.showProductStatuses(event);
  }

  trackItem(index, product) {
    return product ? index : undefined;
  }

  ionViewWillLeave() {
    if (this.isDealsLoadedSub$) {
      this.isDealsLoadedSub$.unsubscribe();
    }
    if (this.productsSub$) {
      this.productsSub$.unsubscribe();
    }
  }
}
